import { api } from "@/utils/axios";

export const repairService = {
  repairList(body) {
    return api.post(
      "?c=Port&m=Web_Port&module=Set_repair&opt=repair_list",
      body
    );
  },
  ignoreList(ignoreState, body) {
    return api.post(
      `?c=Port&m=Web_Port&module=Set_repair&opt=ignore_list`,
      body
    );
  },
  addFault(body) {
    return api.post("?c=Port&m=Web_Port&module=Set_repair&opt=add_fault", body);
  },
  getDetail(id) {
    return api.post("?c=Port&m=Web_Port&module=Set_repair&opt=repair_con", {
      id,
    });
  },
  returnOrder(body) {
    return api.post(
      "?c=Port&m=Web_Port&module=Set_repair&opt=return_order",
      body
    );
  },
  acceptOrder(id) {
    return api.post("?c=Port&m=Web_Port&module=Set_repair&opt=accept_order", {
      id,
    });
  },
  grabOrder(id) {
    return api.post("?c=Port&m=Web_Port&module=Set_repair&opt=grab_order", {
      id,
    });
  },
  dispatchOrder(id, opt_uids) {
    return api.post("?c=Port&m=Web_Port&module=Set_repair&opt=dispatch_order", {
      id,
      opt_uids,
    });
  },
  delOrder(id) {
    return api.post("?c=Port&m=Web_Port&module=Set_repair&opt=del_order", {
      id,
    });
  },
  recoveryOrder(id) {
    return api.post("?c=Port&m=Web_Port&module=Set_repair&opt=recovery_order", {
      id,
    });
  },
  dispatchMajorList() {
    return api.post(
      "?c=Port&m=Web_Port&module=Set_repair&opt=dispatch_major_list"
    );
  },
  repairOrder(body) {
    return api.post(
      "?c=Port&m=Web_Port&module=Set_repair&opt=repair_order",
      body
    );
  },
  appraiseOrder(body) {
    return api.post(
      "?c=Port&m=Web_Port&module=Set_repair&opt=appraise_order",
      body
    );
  },
  applyOrder(body) {
    return api.post(
      "?c=Port&m=Web_Port&module=Set_repair&opt=apply_order",
      body
    );
  },
  applyAnticipateOrder(body) {
    return api.post(
      "?c=Port&m=Web_Port&module=Set_repair&opt=apply_anticipate_order",
      body
    );
  },
};
